<template>
  <apexchart
    height="100%"
    type="bar"
    :options="options"
    :series="series"
  ></apexchart>
</template>

<script>
import {options} from "./Opcoes";
import {parametros_rota} from "../../helpers/ParametrosRota";
import {logout, nomeMeses} from "../../../../../helpers";
import formatter from "./Formatter"
import {buscarMovimentacoesEstoquesCategoria} from "../../../../../api/compraPorDepartamentos/Categoria";

export default {
  name: "Index",
  mixins: [parametros_rota],
  props: {
    categoria: {
      type: Object,
      required: true
    },
    count_atualizar_detalhes_categoria: Number,
  },
  data: () => ({
    options,
    series: [],
    maxValorEscala: 0
  }),
  watch: {
    categoria() {
      this.buscarDadosGrafico()
    },
    count_atualizar_detalhes_categoria() {
      this.buscarDadosGrafico()
    }
  },
  mounted() {
    this.buscarDadosGrafico()
  },
  methods: {
    buscarDadosGrafico() {
      const {iddepartamento, idsecao, idcategoria} = this.categoria;

      const parametros = {
        iddepartamento,
        idsecao,
        idcategoria,
        filial: this.filial_compra,
        grupo: this.grupo_compra
      };

      this.updateSeriesGrafico([], [], []);

      buscarMovimentacoesEstoquesCategoria(parametros)
        .then(this.updateGrafico)
        .catch(logout);
    },
    updateGrafico({referencias, entradas, saidas, estoques}) {
      this.setMaxEscala(entradas, saidas, estoques);
      this.updateOptions(referencias);
      this.updateSeriesGrafico(entradas, saidas, estoques);
    },
    setMaxEscala(entradas, saidas, estoque) {
      const arrayFull = [...entradas, ...saidas, ...estoque];

      this.maxValorEscala = Math.ceil(arrayFull.reduce((a, b) => Math.max(a, b)));
    },
    updateOptions(labels) {
      labels = labels.map(dataPedido => {
        const [mes, ano] = dataPedido.split('/');
        const mesTxt = nomeMeses[parseInt(mes) - 1] || '';

        return mesTxt.concat('/', ano);
      })

      this.options = {
        labels,
        yaxis: {
          labels: {
            formatter: (n) => {
              return formatter(n);
            }
          },
          forceNiceScale: true,
          min: 0,
          max: parseInt(this.maxValorEscala + this.maxValorEscala / 4) || 5
        }
      }
    },
    updateSeriesGrafico(entradas, saidas, estoque) {
      this.series = [
        {
          name: "Entradas",
          color: "#043554",
          type: "column",
          data: entradas,
        },
        {
          name: "Saídas",
          color: "#D60E2B",
          type: "column",
          data: saidas,
        },
        // {
        //   name: "Estoque Médio",
        //   color: "#888",
        //   type: "area",
        //   data: estoque,
        // },
      ];
    }
  }
}
</script>

<style scoped>

</style>
